import log from "loglevel";
import { apiCoreEndpoint } from "settings";
import * as t from "./types";
import { processServiceResponse } from "lib/request";

export const kibanaLoginService = (request: t.KibanaLoginRequestType) => {
  const KIBANA_LOGIN_API_ENDPOINT = `${apiCoreEndpoint}/kibana/login`;
  log.info("Kibana Login Service Request: ", request);
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(KIBANA_LOGIN_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, KIBANA_LOGIN_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};
